import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import CodeMirrorItem from '../components/CodeMirrorItem';
import TutorialItem from '../components/TutorialItem';
import { config, quickStart } from '../../.temp/asset';
import { generateIframePage } from '../utils/domUtils';
import translate from '../../i18n/translate';


class QuickStart extends Component {
    constructor(props) {
        super(props);
    }

    generateTutorial(quickStart) {
        let codeMirrorOptions = {
            lineNumbers: true,
            mode: 'htmlmixed',
            viewportMargin: Infinity,
            foldGutter: true,
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter']
        };
        let result = [];
        let pageContent = {
            reference: null,
            htmlBody: null,
            inlineStyle: null,
            inlineScript: null,
            htmlBodyStyle: "style='font-size:14px;'"
        };
        let i;
        let j;
        let len;
        let len2;
        let tutorial;
        let step;
        let tutorials_res = this.props.strings;

        for(var key in quickStart) {
            var content = quickStart[key];
            tutorials_res = tutorials_res[key];
            for (i = 0, len = content.length; i < len; i++) {
                tutorial = content[i];
                tutorial.title = tutorials_res[i].title || tutorial.title;
                tutorial.description = tutorials_res[i].description || tutorial.description;
                for (j = 0, len2 = tutorial.steps.length; j < len2; j++) {
                    step = tutorial.steps[j];
                    step.description = tutorials_res[i].steps[j].description || step.description;
                    var str;
                    if(step.key === 'inlineScript' && pageContent[step.key] && pageContent[step.key].lastIndexOf('};') > 0) {
                        str = pageContent[step.key].substring(0, pageContent[step.key].length - 2) + step.value + '};';
                    }
                    pageContent[step.key] = str || step.value;
                }
                var reference = pageContent && pageContent.reference;
                if(reference .indexOf('/spread/gc.spread.sheets') < 0) {
                    reference = reference.replace('href="', 'href="css/spread/');
                    reference = reference.replace('src="', 'src="js/spread/');
                    if (reference.indexOf("resources") >= 0) {
                        let culture = reference.substr(reference.indexOf('resources.') + 10, 2);
                        reference = reference.replace('src="gc.spread.sheets.resources', 'src="js/spread/resources/' + culture + '/' + 'gc.spread.sheets.resources');
                    }
                }
                pageContent.reference = reference;
                let key = "step" + i;
                let subKey;
                result.push(
                    <div className="tutorials-wrapper" key={key}>
                        <h2>{tutorial.title}</h2>
                        <p>{tutorial.description}</p>
                        <h3>{this.props.strings.quickStart.steps}</h3>
                        <ol>
                            {tutorial.steps.map(function (step, index) {
                                subKey = 'step' + i + 'desp' + index;
                                return <li key={subKey}>
                                    <span>{step.description}</span>
                                    <CodeMirrorItem htmlContent={step.value} options={codeMirrorOptions}></CodeMirrorItem>
                                </li>
                            })}
                        </ol>
                        <TutorialItem htmlContent={generateIframePage(pageContent)}></TutorialItem>
                    </div>
                )
            }
        }
        return result;
    }

    render() {
        return (
            <div className="mainContent">
                {this.generateTutorial(quickStart)}
            </div>
        );
    }
}



const decorators = _.flow([
    connect(),
    translate('quickStart')
]);

export default decorators(QuickStart)


// WEBPACK FOOTER //
// ./client/containers/QuickStart.js